import { Benefit } from '@pxtra-client-lib-legacy/types';
import { cn } from '../../../../util';
import { useTranslation } from 'react-i18next';
import { BenefitIcon } from '../../../compound/dataDisplay';
import { CheckmarkOutlinedIcon } from '../../../../icons';

export interface BenefitCardProps {
  benefit: Benefit;
}

const getCardStyles = (isSelected?: boolean) => {
  return cn(
    'max-w-full p-3 flex gap-x-3 items-center justify-between bg-white border border-solid border-grey-100 rounded-xl',
    isSelected && 'border-heaven-600'
  );
};

export const BenefitCard = ({ benefit }: BenefitCardProps) => {
  const { t } = useTranslation();
  return (
    <div className={getCardStyles()}>
      <div className="flex gap-x-3 items-center">
        <BenefitIcon benefitKey={benefit} size={32} />
        <div className="leading-6">{t(`benefits:${benefit}`)}</div>
      </div>
      <CheckmarkOutlinedIcon className="w-5 h-5" />
    </div>
  );
};
